var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.hostClass},[(!_vm.hydrated)?_c('p',{class:_vm.$style.message},[_vm._v("Loading...")]):(_vm.activities.length)?_c('ul',{class:_vm.$style.activities},_vm._l((_vm.activities),function(activity){return _c('activity',{key:activity.id,attrs:{"activity":activity}})}),1):_c('p',{class:_vm.$style.message},[_vm._v("\n    Your team have no live calls at the moment.\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0936d728","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-components/live-coach/components/live-coach.vue
// module id = pKWj
// module chunks = 1